import { get, isPlainObject } from "lodash-es";
import type { FieldErrors, FieldValues, FormState } from "react-hook-form";
import type { IntlShape } from "react-intl";

function isRecord(value: unknown): value is Record<string, unknown> {
  return isPlainObject(value);
}

function getMessage(node: unknown): string | undefined {
  if (!isRecord(node)) return undefined;
  const msg = node["message"];
  return typeof msg === "string" ? msg : undefined;
}

export function getRHFErrorsRecursive<T extends FieldValues>(
  rhfErrors: FieldErrors<T>,
  rhfTouched?: FormState<T>["touchedFields"],
  submitCount = 0,
  intl?: IntlShape,
) {
  const errors: string[] = [];
  const triedSubmitting = submitCount > 0;

  const walk = (node: unknown, path: string[]) => {
    if (!node) return;

    const msg = getMessage(node);
    if (msg) {
      const touchedVal = rhfTouched ? get(rhfTouched, path) : undefined;
      const isTouched = touchedVal === true;

      if (triedSubmitting || isTouched) {
        errors.push(intl ? intl.formatMessage({ id: msg }) : msg);
      }
      return;
    }

    if (isRecord(node)) {
      for (const key of Object.keys(node)) {
        walk(node[key], [...path, key]);
      }
    }
  };

  walk(rhfErrors, []);
  return errors;
}
